<!-- eslint-disable max-len -->
<template>
  <li class="nav-item active">
    <a
      class="nav-link"
      :class="{
        btn: pillButton,
      }"
      :style="{
        'border-radius': pillButton ? '25px' : undefined,
        'padding': pillButton ? '4px 10px' : undefined,
        'transform': pillButton ? 'scale(1.18)' : undefined,
        'text-shadow': pillButton ? 'none' : undefined,
      }"
      href="#"
      id="supportTicketMenu"
      role="button"
      @click="onNavButtonClicked"
      aria-expanded="false"
    >
      {{buttonText || 'contact support'}}
    </a>
    <b-modal :ok-disabled="!isValid || submitting" :cancel-disabled="submitting" centered ref="submitModal" title="Support Request" size="lg" @ok="onOkClicked" ok-title="Submit">
      <text-input
        label
        v-model="subject"
        no-count
      >Ticket Subject</text-input>
      <text-input
        textarea
        label
        v-model="description"
        no-count
      >Please describe the problem in more detail</text-input>
      <text-input
        label
        v-model="contactEmail"
        no-count
      >Contact Email</text-input>
      <template v-if="canSeeScreenshot">
        <img style="max-width: 100%; object-fit: contain;" :src="imageUrl" />
        <i>
          <div>Note: Screen capture is still work in progress. There are two known issues at the moment:</div>
          <div style="padding-left: 20px;">- Scrolled elements display scrolled all the way to the top.</div>
          <div style="padding-left: 20px;">- Some text blocks currently wrap incorrectly.</div>
          <div>If you encounter an issue that is not described above, please report it!</div>
        </i>
      </template>
    </b-modal>
  </li>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image-more';

import TextInput from '../../ui/inputs/TextInput';

async function captureScreenshot() {
  // const canvas = document.createElement('canvas');
  // const context = canvas.getContext('2d');
  // const video = document.createElement('video');

  // try {
  //   const captureStream = await navigator.mediaDevices.getDisplayMedia({ video: { frameRate: 1 },
  // audio: false });
  //   video.srcObject = captureStream;
  //   context.drawImage(video, 0, 0, window.width, window.height);
  //   const frame = canvas.toDataURL('image/png');
  //   captureStream.getTracks().forEach(track => track.stop());
  //   return frame;
  // } catch (err) {
  //   console.error(`Error: ${err}`);
  // }

  await new Promise(resolve => setTimeout(resolve, 100));

  // NOTE: Navbar seems to cause this to fail on firefox.  Hence only screenshotting the router root.
  // const ref = document.body;
  const ref = document.getElementById('app-background');
  // eslint-disable-next-line no-return-await
  try {
    let flip = false;

    if (window.matchMedia('screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait)').matches) {
      flip = true;
    }

    return await domtoimage.toJpeg(ref, {
      cacheBust: true,
      quality: 0.5,
      height: flip ? window.innerWidth : window.innerHeight,
      width: flip ? window.innerHeight : window.innerWidth,
    });
  } catch (err) {
    console.error('Failed to capture screenshot.  Error follows.  Returning blank image.');
    console.error(err);
    return 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  }
  // return (await html2canvas(document.body)).toDataURL();
}

window.capScreen = captureScreenshot;

export default {
  components: {
    TextInput
  },

  props: {
    buttonText: String,
    pillButton: Boolean,
  },

  mounted() {
    // autopopulate if logged in with an actual email
    if (this.me && this.me.email && this.me.email.indexOf('@') > 0) {
      this.contactEmail = this.me.email;
    }
    if (this.$route.query.source) {
      this.externalSource = this.$route.query.source;
    }
    if (this.$route.query.id) {
      this.externalId = this.$route.query.id;
    }
    if (this.$route.query.email) {
      this.contactEmail = this.$route.query.email;
    }
  },

  data() {
    return {
      submitting: false,
      capturingScreenshot: false,
      subject: '',
      description: '',
      imageUrl: '',
      contactEmail: '',
      externalSource: '',
    };
  },

  computed: {
    ...mapGetters([
      'canManageUsers',
      'me',
    ]),
    isValid() {
      return this.imageUrl && this.imageUrl.length > 0
          && this.description && this.description.length > 0
          && !this.capturingScreenshot
      ;
    },
    canSeeScreenshot() {
      return false;
    }
  },

  methods: {
    ...mapActions([
      'createSupportTicket'
    ]),
    ...mapMutations([
      'setRootLoadingMessage',
      'setDisableAutoplay',
    ]),
    async onOkClicked(evt) {
      this.submitting = true;
      evt.preventDefault();
      try {
        if ((this.me && this.me.email) || this.contactEmail) {
          await this.createSupportTicket({
            subject: this.subject,
            description: this.description,
            imageUrl: this.imageUrl,
            contactEmail: this.contactEmail,
            externalSource: this.externalSource,
            externalId: this.externalId,
          });
          this.$refs.submitModal.hide();
        } else {
          // eslint-disable-next-line no-alert
          alert('Since you are not logged in, please specify a contact email!');
        }
      } catch (err) {
        console.error(err);
        if (`${err}`.includes('429')) {
          // eslint-disable-next-line no-alert
          alert('Too many support requests from this IP, please try again after 10 minutes, or sign in and try again.');
        } else {
          // eslint-disable-next-line no-alert
          alert('Failed to submit support request.');
        }
      }
      this.submitting = false;
    },
    async captureScreenshot() {
      this.setDisableAutoplay(true);
      this.imageUrl = await captureScreenshot(this.$refs.test);
      this.setDisableAutoplay(false);
    },
    async onNavButtonClicked() {
      this.description = '';
      this.imageUrl = '';

      this.capturingScreenshot = true;
      this.setRootLoadingMessage('Preparing support ticket...');
      await this.$nextTick();
      try {
        await this.captureScreenshot();
      } catch (e) {
        console.error(e);
        // alert('Failed to capture screenshot???');
        return;
      } finally {
        this.setRootLoadingMessage('');
        this.capturingScreenshot = false;
      }
      this.$refs.submitModal.show();
    }
  },
};
</script>

<style lang="scss" scoped>
.env-dropdown-content
{
  color: white;
  padding: 10px;
  width: 350px;
  max-height: 500px;
  overflow-y: auto;
}

header {
  height: 40px;
}
.navbar-root {
  height: 100%;
  padding-top: 4px;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }
}

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  width: 50%;
  height: 100%;
  position: relative;
}
.logo-link {
  outline-color: white;
  height: 100%;
  margin-left: 10px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  height: 100%;
  margin: auto;
  margin-top: -2px;
  text-align: center;
  white-space: nowrap;
  font-size: 16pt;
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
}
.navbar-actionItems {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}
.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}

.state-list-item {
  display: flex;
  margin-bottom: 10px;
  padding: 5px;
  //border: 1px solid rgba(255,255,255,0.3);
  background-color: rgba(17,17,17,0.8);
}

.state-list-item-text
{
  flex-basis: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/SupportTicketInput.vue